module.exports = "<footer class=\"app-footer\">\n  <span>{{ versionLabel }}&nbsp;|&nbsp;2014-{{ currentYear }} &copy; <a href=\"http://www.comparatio.com/\">Comparatio</a></span>\n  <!--<span class=\"ml-auto\">Powered by <a href=\"\"></a></span>-->\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/components/app-footer/app-footer.component.html
// module id = ../../../../../angular/app/components/app-footer/app-footer.component.html
// module chunks = main